export default "__VITE_ASSET__Hedai5co__"